import { STORAGE_KEY_ENUM } from 'enums';
import apiService from 'library/api-service';
import { createAsyncThunk } from '@reduxjs/toolkit';

const initialize = createAsyncThunk('initialize', async () => {
  const response = await apiService.me();

  const permissionCodes = response.data.permissions;
  const allShowBooks = permissionCodes.includes(STORAGE_KEY_ENUM.ALL_SHOW_BOOKS);
  const updateFullBook = permissionCodes.includes(STORAGE_KEY_ENUM.UPDATE_FULL_BOOK);
  const updateCompanyName = permissionCodes.includes(STORAGE_KEY_ENUM.UPDATE_COMPANY_NAME);

  return { permissionCodes, allShowBooks, updateFullBook, updateCompanyName };
});

const permissionsActions = { initialize };

export default permissionsActions;
